import * as React from 'react';
export const IcExploreCompass = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 11a1 1 0 100 2 1 1 0 000-2zm0-9a10 10 0 100 20 10 10 0 000-20zm3.89 7.45L14 13.15a2 2 0 01-.89.89l-3.7 1.85A.93.93 0 019 16a1 1 0 01-.71-.29 1 1 0 01-.18-1.16l1.89-3.7a2 2 0 01.89-.89l3.7-1.85a1 1 0 011.34 1.34h-.04z'
      fill='currentColor'
    />
  </svg>
);
